import React from 'react';
import { connect } from 'react-redux';
import { ButtonStyled, TextStyled } from '@nike/nike-design-system-components';
import { func, bool, object } from 'prop-types';
import { Box, Flex } from 'rebass';

import { showToast } from '../../../components/toast/actions';

import Modal from '../../../modal/Modal';

import { saveAdminDepartmentCatalogTypes as saveCatalogTypes } from '../actions';
import { TranslatedCopy } from '../../../intl/TranslatedCopy';

const title = 'Remove Catalog Type';

const RemoveCatalogTypeModal = ({
  isOpen,
  closeModal,
  department,
  selectedCatalogType,
  updateDepartmentCatalogTypes,
  saveCatalogTypes,
  showToast
}) => {
  const handleRemoveCatalogTypeFromDepartment = async ({ catalogTypeToRemove }) => {
    const updatedCatalogTypes = department.catalogTypes.filter(
      catalogType => catalogType.id !== catalogTypeToRemove.id
    );
    const catalogTypeIds = updatedCatalogTypes.map(({ id }) => id);

    try {
      await saveCatalogTypes({ departmentId: department.id, catalogTypeIds });
      updateDepartmentCatalogTypes(department.id, updatedCatalogTypes);
    } catch (error) {
      showToast({
        type: 'error',
        message: new TranslatedCopy({ id: 'global.toast.systemError' }).toString(),
        error
      });
    }
  };

  const content = () => {
    return (
      <Box width='100%'>
        <TextStyled appearance='title4'>
          {`Are you sure you want to remove ${selectedCatalogType?.name} from ${department.name}?`}
        </TextStyled>
      </Box>
    );
  };

  const footer = ({ toggleIsLoading }) => {
    const handleSubmit = async () => {
      toggleIsLoading(true, 'Removing Catalog Type...');

      await handleRemoveCatalogTypeFromDepartment({
        catalogTypeToRemove: selectedCatalogType
      });

      toggleIsLoading(false);

      closeModal();
    };

    return (
      <Flex>
        <ButtonStyled
          data-testid='remove-catalog-type-cancel-button'
          type='button'
          appearance='secondary'
          background='light'
          size='small'
          onClick={closeModal}
          style={{ marginRight: '15px' }}
        >
          Cancel
        </ButtonStyled>

        <ButtonStyled
          data-testid='remove-catalog-type-submit-button'
          type='button'
          appearance='primary'
          background='light'
          size='small'
          onClick={handleSubmit}
        >
          Remove
        </ButtonStyled>
      </Flex>
    );
  };

  return <Modal title={title} content={content} footer={footer} isOpen={isOpen} closeModal={closeModal} />;
};

RemoveCatalogTypeModal.propTypes = {
  closeModal: func.isRequired,
  isOpen: bool,
  department: object,
  selectedCatalogType: object.isRequired,
  updateDepartmentCatalogTypes: func.isRequired,
  saveCatalogTypes: func.isRequired,
  showToast: func.isRequired
};

RemoveCatalogTypeModal.defaultProps = {
  isOpen: false,
  department: {}
};

export default connect(null, { saveCatalogTypes, showToast })(RemoveCatalogTypeModal);
